import axios from 'axios'
import config from '../config'
import {JsonHeaders} from "../constants";

export default {

    getCategories() {
        return axios.get(config.publicPath + 'categories/tree', {
            headers: JsonHeaders
        });
    },
    createCategory(name, parent) {
        parent ? parent = '/api/categories/' + parent : '';
        return axios.post(config.publicPath + 'categories', {name, parent}, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            },
        });
    },
    getCategory(id) {
        return axios.get(config.publicPath + 'categories/' + id);
    },
    updateCategory(id, category) {
        return axios.put(config.publicPath + 'categories/' + id, {name: category});
    },
    deleteCategory(id) {
        return axios.delete(config.publicPath + 'categories/' + id, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
    getCategorySelect() {
        return axios.get(config.publicPath + 'categories', {
            params: {'groups[]': 'select', 'pagination': false},
            headers: JsonHeaders
        });
    }
}
